// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { FailedToLoad } from '@auto/react-comps';
import App from './App';
import '@auto/jr_fe_tools/common/rem';
import './assets/css/base.css';
import 'antd-mobile/dist/antd-mobile.css';

/**
 * 组件渲染错误后的 fallback 组件
 * @param param0
 * @returns
 */
function ErrorFallback({ error }) {
  console.log(error);
  return <FailedToLoad btnText="点击刷新" callback={() => window.location.reload()} />;
}

/**
 * 组件渲染错误日志记录
 * @param error
 * @param info
 */
function ErrorHandler(error, info) {
  console.log(error, info);
}
ReactDOM.render(
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={ErrorHandler}>
    <Router>
      <Route component={App} />
    </Router>
  </ErrorBoundary>,
  document.getElementById('root'),
);
